import React, { useState, useEffect } from "react";
import HeaderAll from "../components/HeaderAll";
import { Container, CardDeck } from "react-bootstrap";
import Project from "../components/Project";
import { useStateValue } from "../Stateprovider";

function MyProjects() {
  const [{ basket, user, locked, projects }, dispatch] = useStateValue();

  return (
    <div>
      <HeaderAll></HeaderAll>
      <br></br>
      <Container>
        <h1>My Projects</h1>
        <CardDeck>
          {projects?.map((project) => (
            <Project order={project}></Project>
          ))}
        </CardDeck>
      </Container>
    </div>
  );
}

export default MyProjects;
